/**
 * Labels for complaint history. Started from app-pwa src/language/en.ts; the redesigned flow has
 * since added portal-only strings, so the two no longer match.
 */
export const complaintHistoryLabels = {
  complaintHistoryWhenLabel: "When did it start?",
  complaintHistoryHowLabel: "How did it start?",
  complaintHistoryHowOftenLabel: "How often do you experience it?",
  today: "Today",
  yesterday: "Yesterday",
  thisWeek: "This week",
  exactDate: "I know the exact date",
  exactDateLabel: "Exact date",
  onsetDetailLabel: "Describe how it started",
  onsetDetailPlaceholder: "e.g. lifting a box at work",
  optional: "(optional)",
  finishFailed: "We couldn't submit your history. Please try again.",
  answerToContinue: "Answer this to continue",
  severityQuestion: "How severe is it right now?",
  sleepQuestion: "How much does it affect your sleep?",
  workQuestion: "How much does it affect your work?",
  qualityQuestion: "How would you describe it?",
  minimal: "1 = minimal",
  severe: "10 = severe",
  noEffect: "0 = no effect",
  worstEffect: "10 = can't at all",
  weeksAgo: "Weeks ago",
  monthsAgo: "Months ago",
  yearsAgo: "Years ago",
  suddenlyAllAtOnce: "Suddenly (all at once)",
  graduallyOverTime: "Gradually (over time)",
  afterAnAccident: "After an accident",
  afterAnInjury: "After an injury",
  unknownNotSure: "Unknown/Not sure",
  constantAlwaysPresent: "Constant",
  intermittentComesAndGoes: "Intermittent (comes and goes)",
  occasionalAFewTimesPerWeek: "Occasional (a few times per week)",
  rareLessThanOncePerWeek: "Rare (less than once per week)",
  sharp: "Sharp",
  dull: "Dull",
  aching: "Aching",
  burning: "Burning",
  throbbing: "Throbbing",
  stabbing: "Stabbing",
  shooting: "Shooting",
  tingling: "Tingling",
  Numbness: "Numbness",
  other: "Other",
  radiationQuestion: "Does the pain radiate or travel?",
  radiationWhere: "Where does it travel?",
  pickWhereItTravels: "Pick at least one place it travels to continue",
  radiationNoPlaces: "Tell us where it travels in the notes on the next step.",
  selectAllApply: "Select all that apply",
  yes: "Yes",
  no: "No",
  left: "Left",
  right: "Right",
  both: "Both",
  backButton: "Back",
  continueButton: "Continue",
  pain: "Pain",
  numbness: "Numbness",
  weakness: "Weakness",
  headaches: "Headaches",
  dizziness: "Dizziness",
  wellness: "Wellness",

  // Complaint Factors
  complaintFactors: "Complaint Factors",
  whatMakesItBetter: "What makes it better?",
  whatMakesItWorse: "What makes it worse?",
  additionalInfo: "Additional Information",
  additionalInfoPlaceholder:
    "Is there anything else you would like us to know about your pain?",
  rest: "Rest",
  ice: "Ice",
  heat: "Heat",
  stretching: "Stretching",
  exercise: "Exercise",
  medication: "Medication",
  massage: "Massage",
  changeInPosition: "Change in position",
  nothingMakesItBetter: "Nothing",
  movement: "Movement",
  standing: "Standing",
  sitting: "Sitting",
  walking: "Walking",
  lifting: "Lifting",
  bending: "Bending",
  twisting: "Twisting",
  physicalActivity: "Physical activity",
  nothingMakesItWorse: "Nothing",
  pressure: "Pressure",
} as const;
